import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() titulo: string = null
  @Input() accent: 'red' | 'orange' | 'green' | 'light-blue' | 'purple' | 'grey' | 'teal'
  @Input() warning: { tooltip: string } = null
}
